// extracted by mini-css-extract-plugin
export default {"contentBlock":"TranslationsPage_contentBlock__NeDDx","middleBlock":"TranslationsPage_middleBlock__e3Igx"};